<div class="help-container">
  <i (mouseout)="showHelpInfo = false" (mouseover)="showHelpInfo = true"
    aria-hidden="true"
  class="fa fa-question-circle"></i>
  @if (showHelpInfo) {
    <div class="help-popup">
      <ng-content></ng-content>
    </div>
  }
</div>
